import PropTypes from 'prop-types';

export const catalogItemShape = PropTypes.shape({
  size: PropTypes.string,
  width: PropTypes.number,
  length: PropTypes.number,
  height: PropTypes.number,
  vendor_style_number: PropTypes.string,
  weight: PropTypes.number,
  wms_id: PropTypes.number,
  item_name: PropTypes.string,
  sku: PropTypes.string,
  last_po_receipt_date: PropTypes.string,
});

export default catalogItemShape;
